var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container search"},[_c('search',{attrs:{"tags":_vm.tags,"kwd":_vm.kwd,"id":_vm.id}}),_c('tags',{attrs:{"tags":_vm.tags,"kwd":_vm.kwd,"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }